var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4306 14.6598L22.0206 16.5198C21.3106 19.7198 18.8006 21.9998 15.1806 21.9998H10.4205C6.80053 21.9998 4.29052 19.7198 3.58052 16.5198L3.17052 14.6598C2.97052 13.7498 3.51052 12.7198 4.38052 12.3698L5.80053 11.7998L11.3105 9.58981C11.7905 9.3998 12.3005 9.2998 12.8005 9.2998C13.3005 9.2998 13.8105 9.3998 14.2905 9.58981L19.8006 11.7998L21.2206 12.3698C22.0906 12.7198 22.6306 13.7498 22.4306 14.6598Z",
    fill: "#758295"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8008 8.00002V9.44002C19.8008 9.79002 19.4408 10.04 19.1108 9.90002L14.8408 8.19001C13.5248 7.67825 12.0642 7.68182 10.7508 8.20002L6.49078 9.91002C6.41505 9.9414 6.33274 9.95364 6.25115 9.94565C6.16956 9.93766 6.0912 9.90969 6.02299 9.86421C5.95477 9.81874 5.89882 9.75716 5.86006 9.68492C5.8213 9.61268 5.80095 9.532 5.80078 9.45002V8.00002C5.80078 6.35001 7.15078 5.00001 8.80079 5.00001H16.8008C18.4508 5.00001 19.8008 6.35001 19.8008 8.00002ZM15.3008 5.00001H10.3008V3C10.3008 2.45 10.7508 2 11.3008 2H14.3008C14.8508 2 15.3008 2.45 15.3008 3V5.00001Z",
    fill: "#758295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipDisabled);
export default __webpack_public_path__ + "static/media/ship_disabled.3d07889401586324a4d3b706be9217a3.svg";
export { ForwardRef as ReactComponent };